import { render, staticRenderFns } from "./Inativos.vue?vue&type=template&id=f36eadb6&scoped=true"
import script from "./Inativos.vue?vue&type=script&lang=js"
export * from "./Inativos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36eadb6",
  null
  
)

export default component.exports